import { SET_MESSAGE, CLEAR_MESSAGES } from "../actions/actionTypes";

const initState = {
  messages: [],
};

const pushMessage = (state, message) => {
  return [...state.messages, message];
};

export const toastReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_MESSAGE:
      return {
        ...state,
        messages: pushMessage(state, action.payload),
      };
    case CLEAR_MESSAGES:
      return { ...state, messages: [] };
    default:
      return state;
  }
};
